import React from "react";
import { useSelector } from "react-redux";

import { getBiller } from "selectors";
import { IImageResources, IContactInfo } from "types/biller";
import { BillerLogo } from "components/ezpay/common/biller-logo";
import { PayableBreadcrumb } from "components/ezpay/common/payable-breadcrumb";

interface PayableCardHeaderProps {
  showBreadcrumb?: boolean;
}

export function PayableCardHeader({ showBreadcrumb = true }: PayableCardHeaderProps) {
  const biller = useSelector(getBiller);

  const imageResources = biller?.properties?.find((element) => {
    return element.name === "ImageResources";
  }) as IImageResources;

  const contactUs = biller?.properties?.find((element) => {
    return element.name === "InstanceConfiguration";
  }) as IContactInfo;

  return (
    <div className="payable-card-header">
      {showBreadcrumb && <PayableBreadcrumb />}

      <BillerLogo
        billerLogo={imageResources?.properties?.logoURL}
        billerUrl={contactUs?.properties?.website}
      />
    </div>
  );
}
